import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import AsideNav from './AsideNav/AsideNav';
import { IoIosLogOut } from 'react-icons/io';
import { toast } from 'react-toastify';
import './AdminDashboard.css';
import jwtDecode from 'jwt-decode';
import UserTokenHandler from '../../sharedComponents/UserTokenHandler';
import GetLocalStorageUserId from '../../sharedComponents/GetLocalStorageuserId';
import { redirectToIdentityLogin } from '../../../utils/identityLogin';
import axios from 'axios';
const AdminDashboard = () => {
  const [userId, setUserId] = useState(null);
  const move = useNavigate();
  const backendUrl = process.env.REACT_APP_API_URL;
  UserTokenHandler();
  useEffect(() => {
    setUserId(GetLocalStorageUserId());
  }, []);

  const handleLoginClick = () => {
    redirectToIdentityLogin(window.location.origin);
  };
  const logoutHandle = () => {
    toast.success('Logout Successfull', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });
    localStorage.removeItem('sundorbonBookingUserDetails');
    localStorage.removeItem('token');
    move('/');
  };
  const [isSyncing, setIsSyncing] = useState(false);
  const handleSyncClick = () => {
    if (!isSyncing) {
      setIsSyncing(true);
      axios
        .get(
          'https://api.currencyapi.com/v3/latest?apikey=cur_live_8yU35ERIQLgyu2nJ5NFQNRtwb3Z9XVaMTXdygf1j&currencies=BDT%2CUSD%2CCAD%2CBDT&&base_currency=GBP'
        )
        .then((response) => {
          axios
            .post(`${backendUrl}Parcel/ReceiveRates`, response.data)
            .then((response2) => {
              setIsSyncing(false);
              toast.success('Exchange Rate Sync Successfull', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
              });
            })
            .catch((error) => {
              setIsSyncing(false);
              toast.error('Exchange Rate Sync Failed', {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'colored',
              });
            });
        })
        .catch((error) => {
          setIsSyncing(false);
          toast.error('Exchange Rate Sync Failed', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        });
    } else {
      toast.error('Already Syncing', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }
  };

  return (
    <div className='bg-[#fff6f1]'>
      {userId ? (
        <div className='absolute top-3 right-5 z-30 flex items-center gap-3'>
          <button
            onClick={handleSyncClick}
            disabled={isSyncing}
            className='lg:flex hidden items-center gap-2 font-medium text-lg bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[8px] h-[47px] px-3 text-white'
          >
            {!isSyncing ? (
              <span>Sync Exchange Rate</span>
            ) : (
              <span>Syncing...</span>
            )}
          </button>
          <button
            onClick={logoutHandle}
            className='lg:flex hidden items-center gap-2 font-medium text-lg bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[8px] h-[47px] px-3 text-white'
          >
            Logout <IoIosLogOut className='text-xl' />
          </button>
        </div>
      ) : (
        <button
          className='lg:flex hidden absolute top-3 right-5 z-30 items-center gap-2 font-medium lg:mt-4 text-lg bg-gradient-to-tr from-[#6D4C41] rounded-[8px] h-[47px] px-3 to-[#424242] text-white'
          onClick={handleLoginClick}
        >
          Login
        </button>
      )}

      <div className='min-h-screen lg:pt-6 xl:gap-x-[50px] lg:gap-[20px] flex lg:flex-row flex-col items-start '>
        <AsideNav></AsideNav>

        <div className='w-full relative z-10 lg:w-[75%] xl:w-[80%] pt-8 lg:pt-[100px] lg:px-[0px] min-h-screen'>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
